import { BackendApiService, ConfigService } from '@shared/core';
import { Injectable } from '@angular/core';
import { CONTACT } from '../actions/index';
import { ContactSubmitFormAction, ContactSubmitFormFailureAction, ContactSubmitFormSuccessAction } from '../actions/contact-actions';
import { Action } from '../action';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ContactEffects {
	@Effect({ dispatch: true })
	submit$: Observable<Action> = this.actions$.pipe(
		ofType<ContactSubmitFormAction>(CONTACT.SUBMIT_FORM),
		switchMap(action => {
			return this.backendApi.contactUs(action.payload).pipe(
				map((res: any) => new ContactSubmitFormSuccessAction(res)),
				catchError(error => of(new ContactSubmitFormFailureAction(error)))
			);
		})
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private config: ConfigService,
		private backendApi: BackendApiService
	) {}
}
